import { QueryObserverResult, useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS, getFilterConsultationTypes, GetFilterTypesResponse } from 'api';
import { QueryDefaults } from '../../constants/QueryDefaults';

export const useFilterConsultationTypes = (): QueryObserverResult<GetFilterTypesResponse> =>
  useQuery(
    [API_QUERY_KEYS.getFilterConsultationTypes],
    getFilterConsultationTypes,
    QueryDefaults
  );
